module.exports = __webpack_public_path__ + "static/scale-model-of-gulfport-welcome-center-in-st.-petersburg-florida-69f11ba52a2411ca5626bb610a509458.png";